'use strict';
import * as model from './model.js';
import { MODAL_CLOSE_SEC, URL } from './config.js';
import signupView from './views/signupView.js';
import loginView from './views/loginView.js';
import profileView from './views/profileView.js';
import nologinView from './views/nologinView.js';
import forgotPasswordView from './views/forgotPasswordView.js';
import resetPasswordView from './views/resetPasswordView.js';
import productResultView from './views/productResultView.js';
import productView from './views/productView.js';
import addProductView from './views/addProductView.js';
import editProductView from './views/editProductView.js';
import singleOrderView from './views/singleOrderView.js';
import singleOrderPaymentView from './views/singleOrderPaymentView.js';
import ordersView from './views/ordersView.js';
import adminOrderlistView from './views/adminOrderlistView.js';
import adminOrderView from './views/adminOrderView.js';
import adminProductListView from './views/adminProductListView.js';
import homeView from './views/homeView.js';
import contactView from './views/contactView.js';
import aboutView from './views/aboutView.js';
import termsView from './views/termsView.js';
import privacyView from './views/privacyView.js';
import disclaimerView from './views/disclaimerView.js';
import refundView from './views/refundView.js';
// import axios from 'axios';

import 'core-js';
import 'regenerator-runtime/runtime';
import orderView from './views/orderView.js';

const controlHome = async () => {
  try {
    // 1) Render spinner
    homeView.renderSpinner();
    // 2) Render Home Page
    homeView.render('_');
  } catch (err) {
    console.error(err.message);
  }
};

const controlSignup = async signupData => {
  try {
    // 1) Signup User
    await model.signupUser(signupData);
    // 3) Get formdata

    setTimeout(() => {
      signupView.closePopup();
      location.reload(true);
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);
    signupView.renderError(
      err.message.includes('Duplicate') || err.message.includes('duplicate')
        ? 'Email already registered. Please login.'
        : err.message,
    );
  }
};

const controlLogin = async loginData => {
  try {
    // 1) Login user
    await model.loginUser(loginData);

    setTimeout(() => {
      loginView.closePopup();
      location.reload(true);
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);
    loginView.renderError(err.message);
  }
};

let errorMsg;
const controlNologin = async form => {
  try {
    // // 1) Render nologin

    // 2) Check if signin or signup

    if (form === 'signup') {
      console.log('Signup btn');
      // 1) Render Signup
      signupView.render('_', '_', true, true);

      // 2) Add Signup handler
      signupView.addHandlerSignup(controlSignup);
    }

    if (form === 'login') {
      // 1) Render login
      loginView.render('_', '_', true);

      // 2) Add login handler
      loginView.addHandlerLogin(controlLogin);
    }
  } catch (err) {
    console.error(err.message);

    nologinView.renderError(err.message);
  }
};

const controlLogout = async () => {
  try {
    const data = await model.logoutUser();

    // Render success msg
    profileView.renderMessage(data.message);

    // Render no login
    setTimeout(() => {
      // Refresh page
      location.reload(true);
      errorMsg = 'You are not logged in! Please login to get access (401)';
      // 1) Render nologin
      nologinView.render(errorMsg);
      controlNologin();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    profileView.renderError(err.message);
  }
};

const controlProfile = async formData => {
  try {
    // Load user
    model.state.user.id || (await model.loadUser());

    // Render user profile
    profileView.render(model.state.user);
  } catch (err) {
    console.error(err.message);
    errorMsg = err.message.startsWith('jwt')
      ? 'You are not logged in! Please login to get access (401)'
      : err.message;
    // 1) Render nologin
    nologinView.render(errorMsg);
    controlNologin();
  }
};

const controlProfileUpdate = async formData => {
  try {
    // 2) Update profile data
    console.log(formData);
    await model.updateUser(formData);

    // Render success msg
    profileView.renderMessage('Profile data updated successfully!');

    // Render user profile
    setTimeout(() => {
      profileView.render(model.state.user);
      profileView.closePopup();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    profileView.renderError(err.message);
  }
};

const controlPasswordUpdate = async passData => {
  try {
    await model.updatePassword(passData);

    // Render success msg
    profileView.renderMessage(
      'Password updated successfully! Please login again.',
    );

    // Render user profile
    setTimeout(async () => {
      await controlLogout();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    profileView.renderError(err.message);
  }
};

const controlForgotPassword = async email => {
  try {
    const data = await model.forgotPassword(email);

    forgotPasswordView.renderMessage(data.message);
    setTimeout(() => {
      forgotPasswordView.closePopup();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    forgotPasswordView.renderError(err.message);

    setTimeout(async () => {
      // forgotPasswordView.closePopup();
      forgotPasswordView.render('_');
    }, MODAL_CLOSE_SEC * 1000);
  }
};

const controlResetPassword = async newPass => {
  try {
    const token = window.location.hash.slice(1);
    if (!token)
      throw new Error(
        'No reset token available! Please check your mail and click on the Reset Link again.',
      );

    await model.resetPassword(token, newPass);

    resetPasswordView.renderMessage('Password changed successfully.');

    // window.history.back();

    setTimeout(async () => {
      // Render user profile
      location.assign(`${URL}profile`);
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    //
    console.error(err.message);

    resetPasswordView.renderError(err.message);
  }
};

const controlAdminOrderList = async query => {
  try {
    await model.loadAdminOrderList(query);

    adminOrderlistView.render(model.state.query.orders);
    adminOrderlistView.addHandlerOrderSearch(controlAdminOrderList);
    adminOrderlistView.addHandlerOrder(controlAdminOrder);
  } catch (err) {
    console.error(err.message);
    console.error(err);

    adminOrderlistView.renderError(err.message);
    setTimeout(() => {
      adminOrderlistView.closePopup();
    }, MODAL_CLOSE_SEC * 1000);
  }
};

const adminOrder = (block, timeout) => {
  const renderOrder = () => {
    adminOrderView.render(model.state.query.order, true, true, true);
    adminOrderView.addHandlerOrderUpdate(controlAdminOrder);
    adminOrderView.addHandlerOrderSave(controlAdminOrder);
    adminOrderView.addHandlerOrderPay(controlAdminOrder);
  };

  // (block === 'try'
  //   ? () => {
  //       controlAdminOrderList();
  //       adminOrderView.renderSpinner('popup');
  //     }
  //   : () => {
  //       productView.addHandlerSelectSize('popup');
  //     })();
  // renderOrder();

  if (block === 'try') {
    controlAdminOrderList();
    adminOrderView.renderSpinner('popup');
    renderOrder();
  }
  if (block === 'catch') {
    productView.addHandlerSelectSize('popup');
    renderOrder();
  }
};

const updateAdminOrder = async updateData => {
  try {
    await model.updateAdminOrder(updateData);
    adminOrderView.renderSpinner('popup');
    adminOrderView.renderMessage(
      `Order: #${model.state.query.order._id} 
        ${model.state.query.order.brand} ${model.state.query.order.tag}
        Updated Succesfully.`,
    );

    setTimeout(() => {
      adminOrder('try');
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    adminOrderView.renderError(err.message);

    setTimeout(() => {
      adminOrder('catch');
    }, MODAL_CLOSE_SEC * 1000);
  }
};

const saveAdminOrder = async saveData => {
  try {
    model.state.order.single = model.state.query.order;
    await model.addShipAddress(
      saveData,
      saveData.newAddress ? true : false,
      false,
    );
    model.state.query.order = model.state.order.single;
  } catch (err) {
    console.error(err.message);

    adminOrderView.renderError(err.message);

    setTimeout(() => {
      adminOrder('catch');
    }, MODAL_CLOSE_SEC * 1000);
  }
};

const controlAdminOrder = async (data, type) => {
  try {
    if (type === 'id') {
      await model.loadAdminOrder(data);
      adminOrder('catch');
    }

    if (type === 'update') {
      updateAdminOrder(data);
    }

    if (type === 'save') {
      saveAdminOrder(data);
      updateAdminOrder(model.state.query.order);
    }

    if (type === 'pay') {
      saveAdminOrder(data);
      updateAdminOrder(model.state.query.order);
      await model.payNowCash(model.state.query.order, false);
      adminOrderView.render(model.state.query.order, true, true, true);
      adminOrderView.addHandlerOrderUpdate(controlAdminOrder);
    }
  } catch (err) {
    console.error(err.message);

    adminOrderView.renderError(err.message);

    setTimeout(() => {
      adminOrder('catch');
    }, MODAL_CLOSE_SEC * 1000);
  }
};

const controlShop = async () => {
  try {
    await model.loadShop();
  } catch (err) {
    console.error(err.message);

    productResultView.renderError(err.message);
  }
};

const renderAddProduct = async () => {
  try {
    // 1) Render add product form
    addProductView.render('_', '_', true);
  } catch (err) {
    console.error(err.message);

    addProductView.renderError(err.message);
  }
};

const controlAddProduct = async productData => {
  try {
    // 1) Render add product form

    const product = await model.uploadProduct(productData);

    addProductView.renderMessage(
      `${product.name} by ${product.brand} added to your shop successfully.`,
    );

    setTimeout(async () => {
      addProductView.closePopup();
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);

    addProductView.renderError(err.message);
  }
};

const controlAdminProductList = async query => {
  try {
    // 1) Render add product form
    if (!query) adminProductListView.render('_');
    if (query) {
      await model.loadAdminProductList(query);

      adminProductListView.render(model.state.shop);
    }
    adminProductListView.addHandlerProductSearch(controlAdminProductList);
    adminProductListView.addHandlerEditProduct(controlEditProduct);
  } catch (err) {
    console.error(err.message);
    console.error(err);

    adminProductListView.renderError(err.message);
  }
};

const controlEditProduct = async (productData, type) => {
  try {
    // 1) Render add product form

    if (type === 'id') {
      await model.loadAdminProduct(productData);
      editProductView.render(model.state.product, true, true, true);
      editProductView.addHandlerEditProduct(controlEditProduct);
    }

    if (type === 'formData') {
      await model.editProduct(productData, model.state.product.id);
      editProductView.renderMessage(`Product updated successfully.`);
      setTimeout(() => {
        controlAdminProductList(
          model.state.shop.length === 1
            ? { slug: model.state.shop.at(0).slug }
            : {},
        );
        editProductView.render(model.state.product, true, true, true);
        editProductView.addHandlerEditProduct(controlEditProduct);
      }, MODAL_CLOSE_SEC * 1000);
    }
  } catch (err) {
    console.error(err.message);
    console.error(err);

    editProductView.renderError(err.message);
  }
};

const controlOrderSingleProduct = async orderData => {
  try {
    if (orderData !== 'cod' && orderData !== 'online') {
      if (orderData.newAddress) {
        await model.addShipAddress(orderData);
      }
      if (!orderData.newAddress) {
        await model.addShipAddress(orderData, false);
        model.state.order.single.shipAddress =
          model.state.query.order.shipAddress;
      }

      singleOrderPaymentView.render(model.state.order.single);

      singleOrderPaymentView.addHandlerMakePayment(controlOrderSingleProduct);
    }

    if (orderData === 'online') {
      await model.payNow(model.state.order.session);
    }
    if (orderData === 'cod') {
      await model.payNowCash(model.state.order.single);
    }
  } catch (err) {
    console.error(err.message);

    singleOrderPaymentView.renderError(err.message);
  }
};

const controlProduct = async size => {
  try {
    if (!size) {
      throw new Error('Select Size');
    }

    await model.loadUser();

    await model.createSingleOrder(size);

    singleOrderView.renderSpinner();
    singleOrderView.render(model.state.order.single);
    singleOrderView.addHandlerSaveAddress(controlOrderSingleProduct);
  } catch (err) {
    console.error(err.message);

    if (
      err.message === 'You are not logged in! Please login to get access (401)'
    ) {
      nologinView.render(err.message, '_', true, true);
      nologinView.addHandlerSignupPopup(controlNologin);
      nologinView.addHandlerLoginPopup(controlNologin);
    }
  }
};

const controlSingleOrder = async id => {
  try {
    await model.loadOrder(id);
    console.log(model.state.query.order);
    if (model.state.query.order.paymentMethod)
      orderView.render(model.state.query.order);

    if (!model.state.query.order.paymentMethod) {
      model.state.order.single = model.state.query.order;
      singleOrderView.renderSpinner();
      singleOrderView.render(model.state.order.single);
      singleOrderView.addHandlerSaveAddress(controlOrderSingleProduct);
    }
  } catch (err) {
    console.error(err.message);
  }
};

const controlOrder = async () => {
  try {
    model.state.user.id || (await model.loadUser());

    // 2) Load orders
    await model.loadOrders();
    // Render user order
    ordersView.render(model.state.query.orders);
    // ordersView.addHandlerGetOrder(controlSingleOrder);
  } catch (err) {
    console.error(err.message);
    console.error(err);

    errorMsg = err.message.startsWith('jwt')
      ? 'You are not logged in! Please login to get access (401)'
      : err.message;
    // 1) Render nologin
    nologinView.render(errorMsg);
    controlNologin();

    if (err.message.includes('No order found')) {
      ordersView.renderError(
        "You don't have any order. Redirecting to shop page...",
      );

      setTimeout(() => {
        window.location.assign('/shop');
        // window.location.href = '/shop';
      }, MODAL_CLOSE_SEC * 1000);
    }
  }
};

const controlCart = async () => {
  try {
    model.state.user.id || (await model.loadUser());

    nologinView.renderError(
      "You don't have any product in your cart. Redirecting to shop page...",
    );

    setTimeout(() => {
      window.location.assign('/shop');
      // window.location.href = '/shop';
    }, MODAL_CLOSE_SEC * 1000);
  } catch (err) {
    console.error(err.message);
    errorMsg = err.message.startsWith('jwt')
      ? 'You are not logged in! Please login to get access (401)'
      : err.message;
    // 1) Render nologin
    nologinView.render(errorMsg);
    controlNologin();
  }
};

// /////////////////////////////////
// Pages

const home = () => {
  controlHome();
};

const profile = async () => {
  try {
    // 1) Check if login
    await controlProfile();
    document.title = `Pragya Enterprises - ${model.state.user._id ? model.state.user.name : 'Profile'}`;
    profileView.addHandlerSave(controlProfileUpdate);
    profileView.addHandlerPassword(controlPasswordUpdate);
    profileView.addHandlerLogout(controlLogout);
    profileView.addHandlerRenderProductAdd(renderAddProduct);
    profileView.addHandlerRenderProductEdit(controlAdminProductList);
    profileView.addHandlerRenderAdminOrderlist(controlAdminOrderList);

    addProductView.addHandlerAddProduct(controlAddProduct);
  } catch (err) {
    profileView.renderError(err.message);
  }
};

const forgotPassword = () => {
  document.title = `Pragya Enterprises - Forgot Password`;
  forgotPasswordView.render('_');
  forgotPasswordView.addHandlerForgotPassword(controlForgotPassword);
};

const resetPassword = () => {
  document.title = `Pragya Enterprises - Reset Password`;
  resetPasswordView.render('_');
  resetPasswordView.addHandlerNewPassword(controlResetPassword);
};

const product = async () => {
  try {
    const slug = window.location.search?.slice(1);

    // 1) Load product
    await model.loadProduct(slug);
    document.title = `Pragya Enterprises - ${model.state.product._id ? model.state.product.name : 'Product'}`;
    productView.render(model.state.product);
    productView.addHandlerSelectSize();
    productView.addHandlerBuyProduct(controlProduct);
  } catch (err) {
    productView.renderError(err.message);
  }
};

const orders = () => {
  document.title = `Pragya Enterprises - Orders`;
  // 1) check if user is log in
  const orderId = window.location.hash?.slice(1);

  if (!orderId) {
    controlOrder();
  }

  if (orderId) {
    controlSingleOrder(orderId);
  }
};

const cart = () => {
  document.title = `Pragya Enterprises - Cart`;
  controlCart();
};

const shop = async () => {
  document.title = `Pragya Enterprises - Shop`;
  await controlShop();
  // Render shop
  productResultView.render(model.state.shop);
};

///////////////////////////////////////////////
// Initiating App

const menuNames = document.querySelectorAll('.menu__name');
const activateMenu = menu => {
  menuNames.forEach(menuEl => {
    if (menuEl.textContent.toLowerCase() === menu.toLowerCase()) {
      menuEl.closest('.menu__item').classList.add('menu--active');
      return;
    }
    menuEl.closest('.menu__item').classList.remove('menu--active');
  });
};

const init = async () => {
  const currentUrlObj = window.location;
  // console.log(window.location.toString()); // converts to url
  // console.log(window.location.toString().match()); // converts to array
  // console.log(currentUrlObj);
  // console.log(currentUrlObj.pathname);
  // console.log(currentUrlObj.search);

  // 1) Render nologin

  nologinView.addHandlerSignup(controlNologin);
  nologinView.addHandlerLogin(controlNologin);

  // Home
  if (currentUrlObj.pathname === '/') {
    activateMenu('home');
    home();
  }

  // Signup
  if (currentUrlObj.pathname === '/signup') {
    console.log('Signup page');

    controlSignup();
    // 1) Render Signup Page

    // 2)
  }

  // Login
  if (currentUrlObj.pathname === '/login') {
    // console.log('Login page');
    loginView.render('_', '_', true);
    loginView.addHandlerLogin(controlLogin);
  }

  // Forgot Password
  if (
    currentUrlObj.pathname === '/forgotPassword' ||
    currentUrlObj.pathname === '/forgotpassword'
  )
    forgotPassword();

  // Reset Password
  if (
    currentUrlObj.pathname === '/resetPassword' ||
    currentUrlObj.pathname === '/resetpassword'
  )
    resetPassword();

  // Profile
  if (currentUrlObj.pathname === '/profile') {
    activateMenu('profile');
    profile();
  }

  // Shop
  if (currentUrlObj.pathname === '/shop') {
    activateMenu('shop');
    shop();
  }

  // Product
  if (currentUrlObj.pathname === '/product') {
    activateMenu('product');
    product();
  }

  // Orders
  if (currentUrlObj.pathname === '/orders') {
    activateMenu('orders');
    orders();
  }
  // Orders
  if (currentUrlObj.pathname === '/cart') {
    activateMenu('cart');
    cart();
  }
  // About
  if (currentUrlObj.pathname === '/about') {
    aboutView.render('_');
  }
  // Terms
  if (currentUrlObj.pathname === '/terms') {
    termsView.render('_');
  }
  // Privacy
  if (currentUrlObj.pathname === '/privacy') {
    privacyView.render('_');
  }
  // Disclaimer
  if (currentUrlObj.pathname === '/disclaimer') {
    disclaimerView.render('_');
  }
  // Refund
  if (currentUrlObj.pathname === '/refund') {
    refundView.render('_');
  }
  // Contact
  if (currentUrlObj.pathname === '/contact') {
    contactView.render('_');
  }
};
init();

///////////////////////////////////////////////////////
///////////////////////////////////////////////////////

/*
font stack
Figtree-Regular, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
Figtree-Regular, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
*/

// Change ID in URL
// window.history.pushState(null, '', `#${model.state.recipe.id}`);
// window.history.back();

////////////////////////////////////////////////////////////////
